require('./bootstrap');

import Vue from 'vue'
import App from './App.vue'

import store from './store';
import router from './router'

Vue.config.productionTip = false

// Import Buefy
import Buefy from 'buefy'
Vue.use(Buefy);

// Import Axios
import './plugins/axios'

// Import VueEvents
import VueEvents from 'vue-events';

Vue.use(VueEvents);

// Import Material Design Icons
import '@mdi/font/css/materialdesignicons.css'

// Import VeeValidate
import './plugins/vee-validate';

// Import Vue-Mask
import './plugins/vue-mask';

// let appElement = document.getElementById('app');
// window.performanceID = appElement.dataset.performance;

let vm = new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')

router.replace('/')

router.beforeEach((to, from, next) => {
    vm.$events.fire('showLoader');
    next();
});
